"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var createAnnouncer = function () {
    var announcer = document.createElement('div');
    announcer.style.left = '-100%';
    announcer.style.right = '100%';
    announcer.style.position = 'fixed';
    announcer.style.zIndex = '-1';
    document.body.insertBefore(announcer, document.body.firstChild);
    return announcer;
};
exports.AnnounceContext = React.createContext(function (message, mode) {
    if (mode === void 0) { mode = 'polite'; }
    var announcer = document.body.querySelector('[aria-live]') || createAnnouncer();
    announcer.setAttribute('aria-live', 'off');
    announcer.innerHTML = message;
    announcer.setAttribute('aria-live', mode);
    setTimeout(function () {
        announcer.innerHTML = '';
    }, 500);
});
//# sourceMappingURL=AnnounceContext.js.map